import { DateTime } from 'luxon'
import PredefinedPeriodJson from './interfaces/PredefinedPeriodJson'
import PredefinedPeriodTranslation from './PredefinedPeriodTranslation'
import { Locales } from 'src/i18n'

export default class PredefinedPeriod {
  id: number
  startDate: DateTime
  endDate: DateTime
  translations: { [locale: string]: PredefinedPeriodTranslation }

  constructor(
    id: number,
    startDate: DateTime,
    endDate: DateTime,
    translations: { [locale: string]: PredefinedPeriodTranslation },
  ) {
    this.id = id
    this.startDate = startDate
    this.endDate = endDate
    this.translations = translations
  }

  findTranslationByLocale(locale: Locales): PredefinedPeriodTranslation | null {
    return this.translations[locale] ?? null
  }

  translate(locale: Locales, fallbackLocale: Locales) {
    let translation = this.findTranslationByLocale(locale)

    if (!translation) {
      translation = this.findTranslationByLocale(fallbackLocale)
    }

    return translation
  }

  isExpired(now: DateTime) {
    return now > this.endDate
  }

  static fromJson(data: PredefinedPeriodJson) {
    return new this(
      data.id,
      DateTime.fromISO(data.startDate.date, {
        zone: data.startDate.timezone,
      }),
      DateTime.fromISO(data.endDate.date, {
        zone: data.endDate.timezone,
      }),
      data.translations.reduce(
        (previous, current) => ({
          ...previous,
          [current.locale]: PredefinedPeriodTranslation.fromJson(current),
        }),
        {},
      ),
    )
  }
}
